import React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { userService } from '../../../../core/services'
import * as constants from '../../../../static/constants'
import * as interfaces from '../../../../static/interfaces'
import { Button, InputText, Select } from '../../../atoms'
import { Form } from '../../../molecules'
import SocialLoginButtons from '../../../organisms/SocialLoginButtons'

declare var window: interfaces.IWindow

const FIELDS = {
  username: 'username',
  email: 'email',
  password: 'password',
  user_type: 'user_type',
}

export const USER_TYPE = [{ id: 'guest', label: 'Signup as guest' }]

interface IState {
  confirm: boolean
  email: string
  errors: any
}

class UserRegistrationsNew extends React.Component<{}, IState> {
  constructor(props) {
    super(props)
    this.state = {
      errors: {},
      confirm: false,
      email: null,
    }
  }

  public handleUpdateForm = (errors, hasNoError) => {
    this.setState({ errors })
  }
  public handleSubmit = async (initialValues, values) => {
    try {
      const { flush } = await userService.createUser({ user: values })

      this.setState({
        confirm: true,
        email: values.email,
      })
      if (flush?.message) {
        window.flashMessages.addMessage({ text: flush.message, type: flush.type })
      }
    } catch (error) {
      console.error(error)
    }
  }

  public render() {
    return (
      <Wrapper>
        {!this.state.confirm && (
          <UserTypeNote>{I18n.t('session.this_is_signup_page_for_guest')}</UserTypeNote>
        )}
        <Panel>
          {this.state.confirm ? (
            <div className="Panel_Confirmation">
              <p>
                <span>{this.state.email}</span>
                <br />
                {I18n.t('session.confirm_email')}
              </p>
            </div>
          ) : (
            <Form
              fields={FIELDS}
              handleSubmit={this.handleSubmit}
              handleUpdateForm={this.handleUpdateForm}
            >
              <FormItem>
                <InputText
                  required={true}
                  name="username"
                  defaultValue=""
                  label={I18n.t('generic.username')}
                  placeholder="Username"
                  error={this.state.errors.username}
                />
              </FormItem>
              <FormItem>
                <InputText
                  required={true}
                  name="email"
                  defaultValue=""
                  label={I18n.t('generic.email')}
                  placeholder="Email"
                  error={this.state.errors.email}
                />
              </FormItem>
              <FormItem>
                <InputText
                  required={true}
                  password={true}
                  name="password"
                  defaultValue=""
                  label={I18n.t('generic.password')}
                  placeholder={I18n.t('generic.password')}
                  error={this.state.errors.password}
                />
              </FormItem>
              <div style={{ display: 'none' }}>
                <FormItem>
                  <Select
                    required={true}
                    label="User Type"
                    name="user_type"
                    options={USER_TYPE.map(user_type => ({
                      value: user_type.id,
                      label: user_type.label,
                    }))}
                    defaultValue={USER_TYPE[0].label}
                  />
                </FormItem>
              </div>
              <Buttons id="submit_signup">
                <Button primary={true} backgroundColor={'#FF923E'}>
                  {I18n.t('generic.signup_as_guest')}
                </Button>
                <p>
                  {I18n.t('session.have_account')}{' '}
                  <a href="/users/sign_in">{I18n.t('generic.login')}</a>
                </p>
              </Buttons>
            </Form>
          )}
        </Panel>
        <SocialLoginWrapper>
          <SocialLoginButtons />
        </SocialLoginWrapper>
      </Wrapper>
    )
  }
}

const Wrapper = styled.main`
  padding-top: 36px;
`

const UserTypeNote = styled.div`
  max-width: 600px;
  margin: 0 auto 8px;
  text-align: center;
`

const Buttons = styled.div`
  margin-top: 24px;
  text-align: center;

  > p {
    display: block;
    margin: 16px auto 0;

    a {
      color: ${constants.COLORS.primary};
      text-decoration: underline;
    }
  }

  .Button {
    display: block;
    margin: 0 auto;
    width: 160px;
    height: 40px;
    font-weight: bold;
    font-size: 16px;
  }
`

const Panel = styled.div`
  background-color: ${constants.COLORS.white};
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(21, 27, 38, 0.15);
  max-width: 600px;
  margin: 0 auto;
  padding: 24px;

  .Panel_Confirmation {
    text-align: center;

    span {
      font-weight: bold;
    }
  }
`

const FormItem = styled.div`
  & + & {
    margin-top: 16px;
  }
`

const SocialLoginWrapper = styled.div`
  margin-bottom: 20px;
`

export default UserRegistrationsNew
